import { toUpper } from 'ramda'

/**
 * @param {string} action The base of the types to create
 * @param {string} namespace A namespace path for our types
 */
export default function makeApiTypes(action = '', namespace = '') {
  // handling this error here
  if (typeof action !== 'string') {
    throw new Error('Must be a string')
  }

  const _action = toUpper(action)
  const types = {}
  ;['REQUEST', 'SUCCESS', 'ERROR'].forEach(
    t => (types[`${_action}_${t}`] = `${namespace}/${_action}_${t}`),
  )
  return { ...types }
}
